import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface UsersTabState {
  searchText: string;
}

const formSlice = createGenericFormSlice({
  name: "usersTab",
  initialState: {} as SliceState<UsersTabState>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const usersTabReducer = formSlice.reducer;
export default usersTabReducer;
